import React from 'react';
import { motion } from 'framer-motion';
import { ReferralButton } from './ReferralButton';
import { HeroDashboard } from './HeroDashboard';
const microProof = ['Registro online', 'Múltiples productos', 'Trading con riesgo'];
export function Hero() {
  return <section id="top" className="relative overflow-hidden px-5 pb-24 pt-28 lg:px-8 lg:pb-44 lg:pt-40" data-id="element-92" data-mp="9igvp9iprqk6">
      <HeroBackdrop data-id="element-93" data-mp="1297aw07qkt7q" />

      <div className="mx-auto grid max-w-shell items-center gap-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14" data-id="element-94" data-mp="128frdnreylxt">
        <div className="text-center lg:text-left" data-id="element-95" data-mp="xaxe5l6d5kk0">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-96" data-mp="sb1c3rh88373">
            Página independiente de referido
          </motion.p>

          <motion.h1 initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-5 text-[38px] font-extrabold uppercase leading-[0.95] tracking-tightest text-white sm:text-[54px] lg:text-[64px]" data-id="element-97" data-mp="380vyhwiiarcm">
            Todo tu mundo crypto.
            <span className="mt-1 block text-brand" data-id="element-98" data-mp="3e8efj63mtg2w">En una sola plataforma.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.12,
          ease: [0.23, 1, 0.32, 1]
        }} className="mx-auto mt-6 max-w-[540px] text-[15px] leading-relaxed text-ink-muted lg:mx-0 lg:text-base" data-id="element-99" data-mp="30gzu6sm952so">
            Explora criptomonedas, mercados y herramientas de trading desde una experiencia moderna
            diseñada para usuarios que buscan descubrir nuevas oportunidades en el mundo de los
            activos digitales.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.18,
          ease: [0.23, 1, 0.32, 1]
        }} className="mt-9 flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-center lg:justify-start" data-id="element-100" data-mp="s1rr4kwyw0sp">
            <ReferralButton location="hero_primary" size="lg" showArrow data-id="element-101" data-mp="de6munocvvj7">
              Crear mi cuenta
            </ReferralButton>
            <ReferralButton location="hero_secondary" variant="secondary" size="lg" data-id="element-102" data-mp="1b049mx9rqn0y">
              Explorar Bybit
            </ReferralButton>
          </motion.div>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-[12.5px] text-ink-muted lg:justify-start" data-id="element-103" data-mp="111oln361ftvo">
            {microProof.map((item, i) => <li key={item} className="flex items-center gap-3" data-id="element-104" data-mp="3ltgojuoc2yqg" data-mpi={i}>
                {i > 0 && <span className="h-1 w-1 rounded-full bg-white/25" aria-hidden="true" data-id="element-105" data-mp="3hrd9kw2ghc0f" />}
                {item}
              </li>)}
          </ul>

          <p className="mx-auto mt-5 max-w-[460px] text-[11.5px] leading-relaxed text-white/35 lg:mx-0" data-id="element-106" data-mp="1xavzsqiykkaf">
            El trading de criptomonedas implica riesgos y puede no ser adecuado para todos los
            inversores.
          </p>
        </div>

        <div className="lg:pl-6" data-id="element-107" data-mp="2b1966og7bqxn">
          <HeroDashboard data-id="element-108" data-mp="2b1hj2gcbqw8u" />
        </div>
      </div>
    </section>;
}
function HeroBackdrop() {
  return <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden" aria-hidden="true" data-id="element-109" data-mp="2fzam50ibza4w">
      <div className="hairline-grid absolute inset-0 opacity-60 [mask-image:radial-gradient(70%_60%_at_50%_0%,#000,transparent)]" data-id="element-110" data-mp="2kxc9vyqpbxmp" />
      <div className="absolute -top-40 left-1/2 h-[620px] w-[900px] -translate-x-1/2 rounded-full opacity-70" style={{
      background: 'radial-gradient(50% 50% at 50% 50%, rgba(247,162,59,0.16), rgba(5,5,5,0) 70%)'
    }} data-id="element-111" data-mp="2tzlg4cext4ua" />
      <svg className="absolute inset-x-0 top-24 h-[560px] w-full opacity-[0.55]" viewBox="0 0 1440 560" preserveAspectRatio="none" focusable="false" data-id="element-112" data-mp="zlswvr6wa193">
        <defs data-id="element-113" data-mp="3vh5l09oexc8s">
          <linearGradient id="curveFade" x1="0" y1="0" x2="1" y2="0" data-id="element-114" data-mp="3vhf9ttxq1dcw">
            <stop offset="0%" stopColor="#F7A23B" stopOpacity="0" data-id="element-115" data-mp="e88vpzudsc3f" />
            <stop offset="45%" stopColor="#F7A23B" stopOpacity="0.55" data-id="element-116" data-mp="99xlho06bzko" />
            <stop offset="100%" stopColor="#F7A23B" stopOpacity="0" data-id="element-117" data-mp="98mihqejyvum" />
          </linearGradient>
        </defs>
        {[0, 46, 92, 138].map((offset, i) => <path key={offset} d={`M-60 ${430 - offset} C 260 ${330 - offset}, 470 ${470 - offset}, 760 ${300 - offset} S 1180 ${120 - offset}, 1500 ${190 - offset}`} fill="none" stroke="url(#curveFade)" strokeWidth={1} strokeOpacity={1 - i * 0.22} data-id="element-118" data-mp="3csih3uhz2sws" data-mpi={i} />)}
      </svg>
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-base to-transparent" data-id="element-119" data-mp="2u0po402wl7p2" />
    </div>;
}